/* eslint-disable max-len */
export const HeaderTitle = 'Pro Xtra';
export const GenericErrorMessage = 'An error has occurred. The details could not be displayed at this time. Please tap refresh to try again.';
export const spendToolTipLabel = 'Pro Xtra Loyalty Spend Includes transactions made with Pro Xtra ID or registered tender.';
export const spendToolTipLabel1 = 'Excludes taxes, shipping fees, returns, and gift card purchases.';
export const spendToolTipLabel2 = 'Savings includes amount saved from discounts on full price product,';
export const spendToolTipLabel3 = 'other markdowns, bulk discounts and Pro Xtra exclusive savings.';
export const defaultCompletedDrawerDescription = '**Congrats!** You\'ve maxed out your chances to win.';
export const defaultPostOptInDescription = '**You have not officially entered the sweepstakes.** Finish your entry form to get started.\n\n**To Earn Entries:**';
export const ENDPOINTS = {
  HOMEPAGE: 'homepageWelcomeCard',
  AVAILABLE_PERKS: 'availablePerks',
  INFO_PERKS: 'getPerksHomePageById',
  INFO_OFFERS: 'getPerksHomePageById',
  ACTIVATE_PERKS: 'perkActivation',
  REDEEM_PERKS: 'perkRedemption',
  CHALLENGES_INFO: 'offeredChallenges',
  ACCEPT_CHALLENGES: 'acceptChallenge',
};

// Promotions
export const promotionText = {
  PreferredPricingPromo: 'Getting Closer to Preferred Pricing',
  VolumePricingPromo: 'Save with Volume Pricing',
  PlccAcquisitionPromo: 'The New Pro Xtra Credit Card',
  TextToConfirmPromo: 'Approve Purchases via Text',
  PaintProductsPromo: 'Save 20% on paint products',
  ProXtraGeneralKnowledgePromo: 'Get Rewarded with Pro Xtra',
  ManageProjectMore: 'Manage Projects more effectively',
  RegisteredTender: 'Easy Purchase Tracking',
  AppAwarenessPromo: 'Manage Member Benefits',
  ProOnlineExperiencePromo: 'Online Business Tools',
};

// Tile Constants
export const TILE_LIMIT = 4;
export const TILE_TYPE = { NOTIFICATION: 'NOTIFICATION', PROMOTION: 'PROMOTION' };

// Analytics
const analyticsPrefix = { welcomeCard: 'homepage: welcome:' };
export const analytics = {
  NOTIFICATION: {
    PREFIX: `${analyticsPrefix.welcomeCard} not:`,
    perkStatus: 'perks status: until your next perk',
    availablePerks: 'available perks: your available perks',
    pricingUnlocked: 'pricing unlocked: getting close to unlocking paint rewards',
  },
  TABLET: {
    PREFIX: `${analyticsPrefix.welcomeCard} tablet:`,
    easyPurchaseTracking: 'easy purchase tracking',
    earnProXtraDollars: 'earn pro xtra dollars',
  },
  FOOTER: {
    PREFIX: `${analyticsPrefix.welcomeCard} nav:`,
    Perks: 'perks',
    Pricing: 'pricing',
    Offer: 'offers',
  },
  ANALYTICS_MESSAGE: {
    // PERKS
    WELL_DONE: 'well done',
    Perks_Expiring_Soon: 'perk expiring',
    New_Perk_Unlocked: 'perk unlocked',
    Perks_Available: 'perk available',
    ProXtra_Credit_Card: 'perk plcc',
    Progress_Until_Next_Perk: 'perk progress',

    // OFFERS:
    Offers_Expiring_Soon: 'offer expiring',
    Offers_Available: 'offer available',
    Preferred_Pricing_Unlocked: 'pref pricing unlocked',
    Paint_Rewards: 'paint rewards',
    Elite_Support_Line: 'elite support line',

    // SKINNY BAR:
    Offer_Challenge: 'skinny challenge',
    Register_Tender: 'skinny register',
    BOTTOM_LINK: 'bottom',

    // SWEEPSTAKES:
    SWEEPSTAKES: 'sweepstakes',
  },
  ANALYTICS_LINKS: {
    PERKSLINK: 'PERKS AND OFFERS',
    VIEW_PERKS: 'view perks',
    CHOOSE_PERK: 'choose perk',
    VIEW_OFFERS: 'view offers',
    LEARN_MORE: 'learn more',
    VIEW_PAINT: 'view paint rewards',
    // SKINNY BAR:
    EARN_PROXTRA: 'earn pro xtra',
    REGISTER_CARD: 'register a card',
    // BOTTOM LINK:
    VIEW_BENEFITS: 'view all benefits',
    LEARN_PROXTRA: 'learn about pro xtra',
    // ELITE:
    CONTACT: 'contact',

    // SWEEPSTAKES:
    SWEEPSTAKES: 'sweepstakes',
  },
};

export const VIDEO_ANALYTICS = {
  BUTTON_SUBMISSION: 'button submission',
  VIDEO_START: 'video start',
  VIDEO_COMPLETE: 'video complete',
};

export const SWEEPSTAKES_OVERLAY_EVENTS = {
  // Fired when the drawer type opens
  OPT_IN: 'fifa sweepstakes entry',
  SURVEY: 'fifa entry form',
  DETAILS: 'fifa track your entries',
};

// Sweepstakes Constants
export const SWEEPSTAKES_CONSTANTS = {
  AUTH_CTA_TEXT: (isPurchaser) => (isPurchaser ? 'Switch Accounts to Enter' : 'Sign In to Enter'),
  ENABLE_MOBILE_CTA: true,
  DRAWER_TITLES: {
    SWEEPSTAKES_DETAILS: 'Track Your Entries',
    SWEEPSTAKES_OPT_IN: 'Sweepstakes Entry',
    SWEEPSTAKES_SURVEY: 'Submit Form',
    GIVEAWAY_DETAILS: 'Track Your Entries',
  },
  SWEEPSTAKES_TITLES: {
    SURVEY: 'SURVEY',
  },
  DRAWER_TYPES: {
    OPT_IN: 'opt-in',
    SURVEY: 'survey',
    DETAILS: 'details',
    STEP: 'step',
    UNAUTHENTICATED: 'unauthenticated',
    CHALLENGE_ENDED: 'challenge-ended',
  },
  EMPTY_STATE: {
    CHALLENGE_ENDED_MESSAGE: 'The sweepstakes has ended. The details are no longer available to be displayed.',
  },
  STEP_STATUSES: {
    NEW: 'New',
    COMPLETED: 'Completed',
  },
  // Activity statuses that indicate the user has not yet started earning entries
  PRE_OPT_IN_ACTIVITY_STATUS: ['ELIGIBLE', 'INVITED', 'IN_PROGRESS'],
  EVENT_BUS: {
    TRIGGER_PREFIX: 'loyalty-benefits.',
    TRIGGER_PAYLOAD: {
      'loyalty-benefits.sweepstakes_step-cta_notifications': { sweepstakesNotification: 'notification' },
      'loyalty-benefits.sweepstakes_step-cta_store-mode': { sweepstakesStoreMode: 'storemode' },
      'loyalty-benefits.sweepstakes_step-cta_shop': { sweepstakesShopTab: 'shoptab' },
    }
  },
  URLS: {
    LOGO_FALLBACK: 'https://assets.thdstatic.com/images/v1/loyaltyBenefits/SweepstakesIcon.svg',
    // TODO: Replace with production CDN URL once the asset is available
    BANNER_FALLBACK: 'https://storage.googleapis.com/storage.hd-loyalty-stage.gcp.homedepot.com/Sweepstakes/FIFA_Prizes-Banner-Sawdust-All-Vector.svg',
    // External app store URL for step CTA actions
    APP_STORE: 'http://thd.to/62eqlrjko',
  },
  PATHS: {
    LANDING_PAGE: '/c/fifa-world-cup-2026?drawerList=sweepstakes'
  },
  DEFAULTS: {
    HEADER_LINE1: 'FIFA WORLD CUP 2026\u2122',
    HEADER_LINE2: 'SWEEPSTAKES',
    BG_IMAGE: 'https://dam.thdstatic.com/contentful/heroflattenimage/AdobeStock_171766531_72DPI.jpeg',
  },
  FONT_STYLES: {
    OPTIN_TITLE: {
      fontFamily: '"THDFifaInline", sans-serif',
      fontSize: '32px',
      lineHeight: '1.2',
      letterSpacing: '1px',
    },
    OPTIN_SUBTITLE: {
      fontFamily: '"THDFifaInline", sans-serif',
      fontSize: '48px',
      fontWeight: 350,
      lineHeight: '1.1',
      textTransform: 'uppercase',
      letterSpacing: '1px',
    },
    DRAWER_TITLE: {
      fontFamily: '"THDFifaInline", sans-serif',
      fontSize: '3.5rem',
      color: 'white',
      textTransform: 'uppercase',
    },
  },
};

export const DISPLAY_PROGRESS_STATUS = ['IN_PROGRESS', 'COMPLETED', 'OPTED_IN'];